import triggerAllApiEvents from '../triggerAllApiEvents';
import { AppointmentComposeAdapter, getAdapter } from 'owa-addins-apis';
import { ExtensibilityModeEnum } from 'owa-addins-types';
import { getComposeHostItemIndex } from 'owa-addins-store';
import { OutlookEventDispId } from '../schema/OutlookEventDispId';

export function triggerAppointmentTimeChangedEvent(itemId: string) {
    const hostItemIndex = getComposeHostItemIndex(itemId);
    const adapter = getAdapter(hostItemIndex);
    if (adapter != null && adapter.mode === ExtensibilityModeEnum.AppointmentOrganizer) {
        const appointmentComposeAdapter = adapter as AppointmentComposeAdapter;
        triggerAllApiEvents(
            hostItemIndex,
            OutlookEventDispId.APPOINTMENT_TIME_CHANGED_EVENT_DISPID,
            () => {
                return {
                    start: appointmentComposeAdapter.getStartTime(),
                    end: appointmentComposeAdapter.getEndTime(),
                };
            }
        );
    }
}
